export default function PreviewSection() {
	return null;
}



// WEBPACK FOOTER //
// /home/travis/build/cedalo/streamsheets-pro-features/packages/webui-extensions/src/MainDrawerExtensions/PreviewSection.js